export const SET_ACTIVE_TRIGGERS_NUMBER_OF_MENTIONS = 'SET_ACTIVE_TRIGGERS_NUMBER_OF_MENTIONS';

export const setActiveTriggersNumberOfMentions = numberOfMentions => {
  return {
    type: SET_ACTIVE_TRIGGERS_NUMBER_OF_MENTIONS,
    data: numberOfMentions,
  };
};
